/* Change this file to get your personal Portfolio */

// To change portfolio colors globally go to the  _globalColor.scss file

import emoji from "react-easy-emoji";
import splashAnimation from "./assets/lottie/splashAnimation"; // Rename to your file name for custom animation

// Splash Screen

const splashScreen = {
  enabled: true, // set false to disable splash screen
  animation: splashAnimation,
  duration: 2000 // Set animation duration as per your animation
};

// Summary And Greeting Section

const illustration = {
  animated: true // Set to false to use static SVG
};

const greeting = {
  username: "Aqib",
  title: "Hi all, I'm Aqib",
  subTitle: emoji(
    "Passionate React Native developer with 1 year of hands-on experience building high-quality, cross-platform mobile applications. Skilled in crafting intuitive user interfaces and delivering performant, scalable solutions."
  ),
  resumeLink:
    "https://drive.google.com/file/d/1p9-hm-yxih-yQs-Ly0MY9UEw8QbVQbnb/view?usp=sharing", // Set to empty to hide the button
  displayGreeting: true // Set false to hide this section, defaults to true
};

// Social Media Links

const socialMediaLinks = {
  github: "https://github.com/aqibiqbal1",
  linkedin: "https://www.linkedin.com/in/aqibiqbal1/",
  gmail: "aqibiqbal.eng@gmail.com",
  gitlab: "https://gitlab.com/aqibiqbal1",
  facebook:
    "https://www.facebook.com/profile.php?id=100014697306458&mibextid=ZbWKwL",
  medium: "https://medium.com/@mraqib021",
  // stackoverflow: "https://stackoverflow.com/users/10422806/saad-pasta",
  // Instagram, Twitter and Kaggle are also supported in the links!
  // To customize icons and social links, tweak src/components/SocialMedia
  display: true // Set true to display this section, defaults to false
};

// Skills Section

const skillsSection = {
  title: "What I do",
  subTitle: "CRAZY FULL STACK DEVELOPER WHO WANTS TO EXPLORE EVERY TECH STACK",
  skills: [
    emoji(
      "📱 Built and deployed cross-platform mobile apps with React Native, focusing on smooth performance and great user experience."
    ),
    emoji(
      "⚡ Skilled in TypeScript, state management (Redux, Context API), API integration, and mobile UI/UX design best practices."
    ),
    emoji(
      "🤝 Collaborated in agile teams, solved complex technical issues, and stayed updated with the latest mobile development trends."
    )
  ],

  /* Make Sure to include correct Font Awesome Classname to view your icon
https://fontawesome.com/icons?d=gallery */

  softwareSkills: [
    {
      skillName: "html-5",
      fontAwesomeClassname: "fab fa-html5"
    },
    {
      skillName: "css3",
      fontAwesomeClassname: "fab fa-css3-alt"
    },
    {
      skillName: "bootstrap",
      fontAwesomeClassname: "fab fa-bootstrap"
    },
    {
      skillName: "JavaScript",
      fontAwesomeClassname: "fab fa-js"
    },
    {
      skillName: "reactjs",
      fontAwesomeClassname: "fab fa-react"
    },
    {
      skillName: "React Native",
      fontAwesomeClassname: "fab fa-react"
    },
    // {
    //   skillName: "material-ui",
    //   fontAwesomeClassname: "fab fa-mui"
    // },
    // {
    //   skillName: "TypeScript",
    //   fontAwesomeClassname: "fab fa-ts"
    // },
    {
      skillName: "npm",
      fontAwesomeClassname: "fab fa-npm"
    },
    // {
    //   skillName: "sql-database",
    //   fontAwesomeClassname: "fas fa-database"
    // },
    // {
    //   skillName: "aws",
    //   fontAwesomeClassname: "fab fa-aws"
    // },
    {
      skillName: "firebase",
      fontAwesomeClassname: "fas fa-fire"
    }
    // {
    //   skillName: "python",
    //   fontAwesomeClassname: "fab fa-python"
    // },
    // {
    //   skillName: "docker",
    //   fontAwesomeClassname: "fab fa-docker"
    // }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Education Section

const educationInfo = {
  display: false, // Set false to hide this section, defaults to true
  schools: [
    {
      schoolName: "Jawan Pakistan",
      logo: require("./assets/images/harvardLogo.png"),
      subHeader: "Mern Stack Developer",
      duration: "January 2023 - December 2023",
      desc: "Participated in the research of XXX and published 3 papers.",
      descBullets: [
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit"
      ]
    }
  ]
};

// Your top 3 proficient stacks/tech experience

const techStack = {
  viewSkillBars: true, //Set it to true to show Proficiency Section
  experience: [
    {
      Stack: "Frontend", //Insert stack or technology you have experience in
      progressPercentage: "90%" //Insert relative proficiency in percentage
    },
    {
      Stack: "React",
      progressPercentage: "70%"
    },
    {
      Stack: "React Native",
      progressPercentage: "80%"
    }
  ],
  displayCodersrank: true // Set true to display codersrank badges section need to changes your username in src/containers/skillProgress/skillProgress.js:17:62, defaults to false
};

// Work experience section

const workExperiences = {
  display: true, //Set it to true to show workExperiences Section
  experience: [
    {
      role: "React Js Developer",
      company: "Astral Developers",
      companylogo: require("./assets/images/logo.jpeg"),
      date: "February 2024 – March 2024",
      desc: "Experienced web developer proficient in React, Material UI, Bootstrap, and various libraries. Passionate about crafting intuitive user experiences. Skilled in GitHub and Firebase."
      // descBullets: [
      //   "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
      //   "Lorem ipsum dolor sit amet, consectetur adipiscing elit"
      // ]
    },
    {
      role: "Front End Developer",
      company: "Devxonic",
      companylogo: require("./assets/images/devxonic.png"),
      date: "June 2024 – Oct 2024",
      desc: "Front-End Developer at DevXonic, building responsive web applications with React and modern JavaScript.Worked closely with designers and backend teams to create smooth, user-friendly experiences.Focused on clean code, performance optimization, and continuous improvement."
      // descBullets: [
      //   "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
      //   "Lorem ipsum dolor sit amet, consectetur adipiscing elit"
      // ]
    },
    {
      role: "React Native Developer",
      company: "Devxonic",
      companylogo: require("./assets/images/devxonic.png"),
      date: "October 2024 – Present",
      desc: "React Native Developer at DevXonic, building high-quality cross-platform mobile applications.Collaborated with designers and backend teams to deliver smooth, user-centric app experiences.Focused on clean code, performance optimization, and continuous feature improvements."
      // descBullets: [
      //   "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
      //   "Lorem ipsum dolor sit amet, consectetur adipiscing elit"
      // ]
    }
  ]
};

/* Your Open Source Section to View Your Github Pinned Projects
To know how to get github key look at readme.md */

const openSource = {
  showGithubProfile: "true", // Set true or false to show Contact profile using Github, defaults to true
  display: true // Set false to hide this section, defaults to true
};

// Some big projects you have worked on

const bigProjects = {
  title: "Projects",
  subtitle: "Afrimeets — Social Networking App (Freelance Project)",
  projects: [
    {
      image: require("./assets/images/afrimeet.webp"),
      projectName: "Afrimeets",
      projectDesc: "Afrimeets is a social networking app focused on connecting people across Africa through real-time chat, user profiles, and community discovery.Built with React Native for Android, the app features a smooth, intuitive UI and optimized performance for different network conditions.I handled the complete mobile development, ensuring fast load times, clean navigation, and a strong foundation for future cross-platform expansion.",
      footerLink: [
        {
          name: "Visit PlayStore",
          url: "https://play.google.com/store/apps/details?id=com.afrimeets"
        }
        //  you can add extra buttons here.
      ]
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Achievement Section
// Include certificates, talks etc

const achievementSection = {
  title: emoji("Achievements And Certifications 🏆 "),
  subtitle:
    "Achievements, Certifications, Award Letters and Some Cool Stuff that I have done !",

  achievementsCards: [
    {
      title: "Introduction to HTML & CSS",
      subtitle:
        "Microsoft-certified professional in HTML and CSS, skilled at transforming concepts into visually appealing websites. Detail-oriented, deadline-driven, and ready to contribute technical excellence to innovative projects.",
      image: require("./assets/images/microsoftlogo.png"),
      imageAlt: "Microsoft Logo",
      footerLink: [
        {
          name: "View Certification",
          url: "https://www.certiport.com/Portal/Pages/PrintTranscriptInfo.aspx?action=Cert&id=397&cvid=Aof/HFoNhrPGZrfpZgtRBw=="
        }
      ]
    },
    {
      title: "Front End Developer",
      subtitle:
        "Jawan Pakistan-certified Front End Developer proficient in HTML, CSS, JavaScript, Bootstrap, GitHub, and Firebase, with a strong track record of creating dynamic and responsive web applications.",
      image: require("./assets/images/jawanpakistan.png"),
      imageAlt: "Google Assistant Action Logo",
      footerLink: [
        {
          name: "View Certification",
          url: "https://www.certiport.com/Portal/Pages/PrintTranscriptInfo.aspx?action=Cert&id=397&cvid=Aof/HFoNhrPGZrfpZgtRBw=="
        }
      ]
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Blogs Section

const blogSection = {
  title: "Blogs",
  subtitle:
    "With Love for Developing cool stuff, I love to write and teach others what I have learnt.",
  displayMediumBlogs: "true", // Set true to display fetched medium blogs instead of hardcoded ones
  blogs: [
    {
      url: "https://blog.usejournal.com/create-a-google-assistant-action-and-win-a-google-t-shirt-and-cloud-credits-4a8d86d76eae",
      title: "Win a Google Assistant Tshirt and $200 in Google Cloud Credits",
      description:
        "Do you want to win $200 and Google Assistant Tshirt by creating a Google Assistant Action in less then 30 min?"
    },
    {
      url: "https://medium.com/@mraqib021/why-react-is-the-best-5a97563f423e",
      title: "Why REACT is The Best?",
      description:
        "React is a JavaScript library for building User Interface. It is maintained by Facebook and a community of individual developers and companies."
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Talks Sections

const talkSection = {
  title: "TALKS",
  subtitle: emoji(
    "I LOVE TO SHARE MY LIMITED KNOWLEDGE AND GET A SPEAKER BADGE 😅"
  ),

  talks: [
    {
      title: "Build Actions For Google Assistant",
      subtitle: "Codelab at GDG DevFest Karachi 2019",
      slides_url: "https://bit.ly/saadpasta-slides",
      event_url: "https://www.facebook.com/events/2339906106275053/"
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Podcast Section

const podcastSection = {
  title: emoji("Podcast 🎙️"),
  subtitle: "I LOVE TO TALK ABOUT MYSELF AND TECHNOLOGY",

  // Please Provide with Your Podcast embeded Link
  podcast: [
    "https://anchor.fm/codevcast/embed/episodes/DevStory---Saad-Pasta-from-Karachi--Pakistan-e9givv/a-a15itvo"
  ],
  display: false // Set false to hide this section, defaults to true
};

// Resume Section
const resumeSection = {
  title: "Resume",
  subtitle: "Feel free to download my resume",

  // Please Provide with Your Podcast embeded Link
  display: true // Set false to hide this section, defaults to true
};

const contactInfo = {
  title: emoji("Contact Me ☎️"),
  subtitle:
    "Discuss a project or just want to say hi? My Inbox is open for all.",
  number: "+92-337 8210240",
  email_address: "aqibiqbal.eng@gmail.com"
};

// Twitter Section

const twitterDetails = {
  userName: "mraqib021", //Replace "twitter" with your twitter username without @
  display: false // Set true to display this section, defaults to false
};

const isHireable = true; // Set false if you are not looking for a job. Also isHireable will be display as Open for opportunities: Yes/No in the GitHub footer

export {
  illustration,
  greeting,
  socialMediaLinks,
  splashScreen,
  skillsSection,
  educationInfo,
  techStack,
  workExperiences,
  openSource,
  bigProjects,
  achievementSection,
  blogSection,
  talkSection,
  podcastSection,
  contactInfo,
  twitterDetails,
  isHireable,
  resumeSection
};
